import React from 'react';
import './ReliabilityModal.css';

interface ReliabilityModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ReliabilityModal: React.FC<ReliabilityModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const reliabilityLevels = [
    {
      color: '#073763',
      description: 'Очень высокая достоверность (Excellent)',
      comment: 'данные предоставлены компанией референтной группы'
    },
    {
      color: '#1155cc',
      description: 'Высокая достоверность (High)',
      comment: 'данные получены в ходе полевых исследований / верифицированы командой аналитики datacircle'
    },
    {
      color: '#6d9eeb',
      description: 'Умеренная достоверность (Moderate)',
      comment: 'данные предоставлены сотрудником компании / получены из открытых источников / являются результатом работы регрессионной модели datacircle (подтвержденная точность не менее 85%)'
    },
    {
      color: '#999999',
      description: 'Информация требует проверки (Low)',
      comment: 'данные являются результатом работы регрессионной модели datacircle c подтвержденной точностью менее 85% / получены из иных источников'
    }
  ];

  return (
    <div className="reliability-modal-overlay" onClick={onClose}>
      <div className="reliability-modal-content" onClick={(e) => e.stopPropagation()}>
        
        {/* Кнопка закрытия */}
        <button
          onClick={onClose}
          className="reliability-modal-close"
        >
          ×
        </button>

        {/* Заголовок */}
        <h2 className="reliability-modal-title">
          Уровни надежности данных
        </h2>

        {/* Таблица с уровнями надежности */}
        <div className="reliability-table-container">
          <table className="reliability-table">
            <thead>
              <tr>
                <th>Цвет</th>
                <th>Описание</th>
                <th>Комментарий</th>
              </tr>
            </thead>
            <tbody>
              {reliabilityLevels.map((level, index) => (
                <tr key={index}>
                  <td>
                    <div 
                      className="reliability-color-indicator"
                      style={{ backgroundColor: level.color }}
                    ></div>
                  </td>
                  <td>{level.description}</td>
                  <td>{level.comment}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
};

export default ReliabilityModal;
